export default "__VITE_ASSET__6b8b0593__"